// a library to wrap and simplify api calls
import Api from "./PhiApi";
import Constants from "./Constants";
import Role from "./PhiRole";
import JSZip from "jszip";

class PhiUser {
  constructor(options, data = {}) {
    this.phiRef = options;

    this.login = function* (that, credentials) {
      let response = yield Api.userLogin(credentials);

      if (response.ok && response.data) {
        let token = { jwt: response.data.jwt, iat: response.data.iat };
        that.phiRef.setSession(token);
        let checkRoleStatus = false;

        if (response.data.role) {
          let roles = response.data.role.map((a) => {
            if (
              a.role_type_id === Constants.roleIdMapV2["SCHOOL_ADMIN"].value
            ) {
              checkRoleStatus = true;
            } else if (
              a.role_type_id === Constants.roleIdMapV2["Nurse"].value
            ) {
              checkRoleStatus = true;
            }
            return new Role(a);
          });
          roles.sort(function (a, b) {
            if (a.role_type_id > b.role_type_id) {
              return 1;
            } else {
              return -1;
            }
          });
          that.phiRef.Storage.setItem(
            "roles",
            JSON.stringify(response.data.role)
          );
          that.userRoles = roles;
        }

        if (!!checkRoleStatus) {
          let userResponse = yield that.get(that, {
            custom: true,
            profile: true,
            email: true,
            phone: true,
            address: false,
            device: true,
            customer: true,
            organization: true,
          });

          if (userResponse && !userResponse.error) {
            that.userProfile = userResponse.profile;
            that.userProfile.username = userResponse.profile.username;
            that.phiRef.Storage.setItem(
              "profile",
              JSON.stringify(userResponse.profile)
            );
            that.phiRef.Storage.setItem(
              "custom",
              JSON.stringify(userResponse.custom)
            );
            if (userResponse.organization) {
              that.phiRef.Storage.setItem(
                "organization",
                userResponse.organization
              );
            }
            return userResponse;
          }
        } else {
          that.logout();
          return { ok: false, errorCode: 403, error: true };
        }
      } else if (!!!response.ok && !!response.data.error) {
        return { ok: false, errorCode: 401, error: true };
      }

      return null;
    };

    this.magicLinkLogin = function* (that, magicLink) {
      let response = yield Api.magicLinkLogin(magicLink);

      if (response.ok && response.data) {
        let token = { jwt: response.data.jwt, iat: response.data.iat };
        that.phiRef.setSession(token);
        let checkRoleStatus = false;

        if (response.data.role) {
          let roles = response.data.role.map((a) => {
            if (a.role_type_id === Constants.roleIdMapV2["GUEST_USER"].value) {
              checkRoleStatus = true;
            }
            return new Role(a);
          });
          roles.sort(function (a, b) {
            if (a.role_type_id > b.role_type_id) {
              return 1;
            } else {
              return -1;
            }
          });
          that.phiRef.Storage.setItem(
            "roles",
            JSON.stringify(response.data.role)
          );
          that.userRoles = roles;
        }

        if (!!checkRoleStatus) {
          let userResponse = yield that.get(that, {
            custom: true,
            profile: true,
            email: true,
            phone: true,
            address: false,
            device: true,
            customer: true,
            organization: true,
          });

          if (userResponse && !userResponse.error) {
            that.userProfile = userResponse.profile;
            that.userProfile.username = userResponse.profile.username;
            that.phiRef.Storage.setItem(
              "profile",
              JSON.stringify(userResponse.profile)
            );
            that.phiRef.Storage.setItem(
              "custom",
              JSON.stringify(userResponse.custom)
            );
            if (userResponse.organization) {
              that.phiRef.Storage.setItem(
                "organization",
                userResponse.organization
              );
            }
            return userResponse;
          }
        } else {
          that.logout();
          return { ok: false, errorCode: 403, error: true };
        }
      } else if (!!!response.ok && !!response.data.error) {
        return { ok: false, errorCode: 401, error: true };
      }

      return null;
    };

    this.logout = function () {
      let storage = this.phiRef.Storage;
      this.phiRef.removeSession();
      storage.clear();
    };

    this.isAuthenticated = function () {
      let token = this.phiRef.getSession();
      let authenticated = token ? true : false;
      return authenticated;
    };

    this.convertBase64toBlob = (content, contentType) => {
      contentType = contentType || "";
      let sliceSize = 512;
      let byteCharacters = window.atob(content); //method which converts base64 to binary
      let byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, {
        type: contentType,
      }); //statement which creates the blob

      return blob;
    };

    this.parseData = function (result) {
      let user = result;
      user.profile = result.profile ? JSON.parse(result.profile)[0] : {};
      user.role = result.role ? JSON.parse(result.role) : null;
      user.device = result.token ? JSON.parse(result.token) : null;
      user.address = result.address ? JSON.parse(result.address)[0] : null;
      user.email = result.email ? JSON.parse(result.email)[0] : null;
      user.custom = result.custom ? JSON.parse(result.custom)[0] : null;
      user.phone = result.phone ? JSON.parse(result.phone)[0] : null;
      user.customer = result.customer ? JSON.parse(result.customer)[0] : null;
      user.parent_association = result.parent_association
        ? JSON.parse(result.parent_association)
        : null;
      user.profile.username = result.username;
      user.profile.uuid = result.uuid;
      return user;
    };

    this.get = function* (that, config) {
      let token = that.phiRef.getSession();
      if (token) {
        let response = yield Api.getUser(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return that.parseData(response.data.results[0]);
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.put = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.putUser(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.postEpisode = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.postEpisode(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.getStudentReport = function* (that, reportType, config) {
      let token = that.phiRef.getSession(that.phiRef);

      if (token) {
        let htmlContent, pdfContent, styleContent;
        let response = yield Api.getStudentReport(
          config.type === "pdf" ? reportType + "/pdf" : reportType,
          config
        );

        if (response.ok && response.data && response.data.output) {
          let base64 = response.data.output;

          if (config.type === "html") {
            let zipFile = new JSZip();
            let content = yield zipFile.loadAsync(base64, { base64: true });
            if (content && content.files) {
              let files = content.files;
              for (let key in files) {
                let obj = files[key];
                let fileData = yield obj.async("string");
                if (key.endsWith(".css")) {
                  styleContent = fileData;
                } else if (key.endsWith(".zip") || key.endsWith(".htm")) {
                  htmlContent = fileData;
                }
              }

              for (let file in files) {
                let imageBase64 = null;
                let obj = files[file];

                if (file.endsWith(".png")) {
                  imageBase64 = yield obj.async("base64");
                  htmlContent = htmlContent
                    .split(file)
                    .join(`data:image/png;base64, ${imageBase64}`);
                }
              }

              styleContent +=
                ".frame-content >  table { width: 100%; height: 100%; }";
              htmlContent = htmlContent
                .substr(htmlContent.indexOf("<body>"), htmlContent.length)
                .replace(/\n+/g, "")
                .replace(/>\s+</g, "><");
              htmlContent = htmlContent
                .replace("</body></html>", "")
                .replace(`<body>`, `<style>${styleContent}</style>`);

              return { data: htmlContent };
            }
          } else if (config.type === "pdf") {
            pdfContent = that.convertBase64toBlob(base64, "pdf");

            return { data: pdfContent };
          }
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.roles = function () {
      if (!this.userRoles) {
        let roles = this.phiRef.Storage.getItem("roles");
        if (roles) {
          roles = JSON.parse(roles);
          roles = roles.map((a) => new Role(a));
        }
        this.userRoles = roles;
      }
      return this.userRoles;
    };

    this.profile = function () {
      if (!this.userProfile) {
        let profile = this.phiRef.Storage.getItem("profile");
        if (profile) {
          this.userProfile = JSON.parse(profile);
        }
      }
      return this.userProfile;
    };

    this.userCustomJson = function () {
      if (!this.customJson) {
        let custom = this.phiRef.Storage.getItem("custom");
        if (custom) {
          this.customJson = JSON.parse(custom);
        }
      }
      return this.customJson;
    };

    this.uploadUser = function* (that, payload) {
      let token = that.phiRef.getSession();
      if (token) {
        let response = yield Api.uploadUser(payload);

        if (response.ok && response.data) {
          return response;
        }
      }
      return null;
    };

    this.uploadOmr = function* (that, payload, event_track_id) {
      let token = that.phiRef.getSession();
      if (token) {
        let response = yield Api.uploadOmr(payload, event_track_id);

        if (response.ok && response.data) {
          return response;
        }
      }
      return null;
    };
  }
}

export default PhiUser;
